import React, { useEffect, useState } from "react";
import { Settings as SettingsIcon, ExternalLink } from "lucide-react";
import { googlePlacesStatus } from "@/lib/chiroApi";

export default function Settings() {
    const [places, setPlaces] = useState({ configured: null, message: "" });

    useEffect(() => {
        googlePlacesStatus().then(setPlaces);
    }, []);

    const Row = ({ label, value, ok, hint }) => (
        <div
            className="flex items-center justify-between py-3 border-b border-[#262a2e] last:border-b-0"
            data-testid={`settings-row-${label.toLowerCase().replace(/\s+/g, "-")}`}
        >
            <div>
                <div className="font-mono text-[11px] uppercase tracking-[0.15em] text-[#9ca3af]">
                    {label}
                </div>
                {hint && <div className="text-[11px] text-[#6b7280] mt-0.5">{hint}</div>}
            </div>
            <span
                className={`font-mono text-[10px] uppercase tracking-[0.2em] px-2 py-[2px] border rounded-[2px] ${
                    ok
                        ? "text-[#7cc93c] border-[#7cc93c]/40"
                        : "text-[#ff9f0a] border-[#ff9f0a]/40"
                }`}
            >
                {value}
            </span>
        </div>
    );

    return (
        <div data-testid="settings-page" className="max-w-3xl">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#7cc93c] mb-2">
                // settings · integrations + environment
            </div>
            <h1 className="text-3xl font-bold tracking-tight mb-2">Settings</h1>
            <p className="text-[#9ca3af] text-sm mb-6 max-w-2xl">
                Lightweight read-only view. To change a value, edit{" "}
                <code className="font-mono text-[#d1d5db]">/app/backend/.env</code> and restart
                the backend.
            </p>

            <div className="border border-[#262a2e] bg-[#0f1113] rounded-[2px] px-4">
                <Row
                    label="Google Places API"
                    value={places.configured ? "configured" : "missing"}
                    ok={!!places.configured}
                    hint={
                        places.configured
                            ? "Real Google Places (New) is wired into Find Prospects."
                            : "Set GOOGLE_PLACES_API_KEY in /app/backend/.env to enable Find Prospects."
                    }
                />
                <Row
                    label="Auto-send outreach"
                    value="disabled"
                    ok={false}
                    hint="ProofCommand never sends outreach automatically. v2 stops at admin approval."
                />
            </div>

            <div className="mt-6 text-[12px] text-[#6b7280]">
                Need to change shared password, SendGrid, AWS SES, or session secret? Edit{" "}
                <code className="font-mono text-[#9ca3af]">/app/backend/.env</code> and run{" "}
                <code className="font-mono text-[#9ca3af]">sudo supervisorctl restart backend</code>.
            </div>

            <div className="mt-4 flex items-center gap-2 text-[11px] text-[#9ca3af]">
                <SettingsIcon className="w-3.5 h-3.5" />
                <a
                    href="https://developers.google.com/maps/documentation/places/web-service/get-api-key"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:text-[#7cc93c] inline-flex items-center gap-1"
                    data-testid="settings-places-docs"
                >
                    How to get a Google Places API key <ExternalLink className="w-3 h-3" />
                </a>
            </div>
        </div>
    );
}
